import Moment from "moment";

const state = {
    id: 0,
    title: "",
    description: "",
    level: "",
    joinCode: "",
    room_url: null,
    youtubeUrl: null,
    topic: null,
    teachers: null,
    teacher_details: null,
    kuota: null,
    grade: [],
    url: null,
    thumbnail: null,
    type: null,
    groupId: [],
    startDate: null,
    startTime: null,
    endTime: null,
    endDate: null,
    mapel: false,
    isPrivate: false,
    liveclassroomId: "",
    youtubeUrl: "",
    user_group: [],
    record_video_url: "",
    record_video_duration: null,
    presentationPath: "",
    is_special: false,
    user_type: null,
    program_benefit: "",
    material_description: "",
};

const mutations = {
    live_class_init(state, payload) {
        state.id = payload.classId;
        state.title = payload.name;
        state.description = payload.description;
        state.mapel = payload.subject;
        state.teachers = payload.teachers;
        state.teacher_details = payload.teacherDetails;
        state.room_url = payload.roomUrl;
        state.youtubeUrl = payload.youtubeUrl;
        state.meeting_id = payload.meetingId;
        state.room_password = payload.roomPassword;
        state.level = payload.level;
        state.grade = payload.grade;
        state.isPrivate = payload.private;
        state.joinCode = payload.code;
        state.url = payload.thumbnail;
        state.thumbnail = payload.thumbnail;
        state.kuota = payload.quota;
        state.groupId = payload.groupId;
        state.type = payload.type;
        state.youtubeUrl = payload.youtubeUrl;
        state.liveclassroomId = payload.liveclassroomId;
        state.user_group = payload.userGroups;
        state.startDate = Moment(payload.startAt).format("DD/MM/YYYY");
        state.startTime = Moment(payload.startAt).format("HH:mm");
        state.endDate = Moment(payload.endAt).format("DD/MM/YYYY");
        state.endTime = Moment(payload.endAt).format("HH:mm");
        state.record_video_url = payload.record_video_url;
        state.record_video_duration = payload.record_video_duration;
        state.presentationPath = payload.presentationPath;
        state.is_special = payload.is_special;
        state.user_type = payload.user_type;
        state.program_benefit = payload.program_benefit;
        state.material_description = payload.material_description;
    },

    live_class_clear(state) {
        state.id = 0;
        state.title = "";
        state.description = "";
        state.level = "";
        state.joinCode = "";
        state.room_url = null;
        state.youtubeUrl = null;
        state.topic = null;
        state.teachers = null;
        state.teacher_details = null;
        state.kuota = null;
        state.type = null;
        state.grade = [];
        state.url = null;
        state.thumbnail = null;
        state.startDate = null;
        state.startTime = null;
        state.endTime = null;
        state.groupId = [];
        state.endDate = null;
        state.mapel = false;
        state.isPrivate = false;
        state.liveclassroomId = "";
        state.youtubeUrl = "";
        state.user_group = [];
        state.record_video_url = "";
        state.record_video_duration = null;
        state.presentationPath = "";
        state.is_special = false;
        state.user_type = null;
        state.program_benefit = "";
        state.material_description = "";
    },

    liveclass_set_record_video_url: function (state, payload) {
        state.record_video_url = payload;
    },

    liveclass_set_record_video_duration: function (state, payload) {
        state.record_video_duration = payload;
    },
};

export default { state, mutations };



// WEBPACK FOOTER //
// ./src/modules/live_class/stores/liveclass.js